OCR拍照上传组件

<template>
  <el-form-item :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-show="isShow" :prop="field.FIELD_ID"
    :rules="rules">
    <div class="imgList-box">
      <div class="returnImg" v-show="isReturn">影像已被退回</div>
      <div class="returnImg" v-show="isNeedSupple">影像需补采</div>
      <div class="webCamera-box">
        <web-camera v-for="(item, index) in collectedImgData" :key="item.IMG_CLS + item.itemTitle + index"
          class="imgBox capture web-margin" :options="cameraOptions" @onPhotoResult="onPhotoResult" :imgObj="item"
          :index="index" :beforeOpenCamera="beforeOpenCamera" @delImg="imgDelete" @showSwipter="showSwipter"
          :ref="'webCamera' + index"></web-camera>
      </div>
      <span class="web-text">或</span>   
       <!-- 二维码 -->
      <common-qr-code :isDisabled="isDisabled" :qrCodeType="1" @finishScan="finishScan"></common-qr-code>
    </div>
    <div class="swiper_show" v-if="imageSwiper">
      <div class="currentDealImg">
        <!-- <img :src="collectedImgData[image_index].imgSrc" v-if="collectedImgData[image_index].imgSrc" alt="" id="pinchImg" fit="contain"> -->
        <img :src="getSrc(collectedImgData[image_index])" v-if="collectedImgData[image_index].imgSrc" alt=""
          id="pinchImg" fit="contain">
        <div class='noImg' v-if="!collectedImgData[image_index].imgSrc">无图像</div>
      </div>
      <div class="dealButtons">
        <el-button class="takeagain" plain @click.native="takephotoagain(image_index)">重拍</el-button>
        <el-button class="openNew" plain @click.native="openWindow(image_index)">新窗口显示</el-button>
        <!-- <el-button class="imgDelete" plain @click.native="imgDelete(image_index)" v-show="hasPageNum"></el-button> -->
        <el-button class="imgclose" plain text="关闭" @click.native="closebigpage">关闭</el-button>
      </div>
    </div>
  </el-form-item>
</template>

<script>
import WebCamera from "./WebCamera.vue";
import oppService from "@/service/opp-service";
import { deleteCollectedImgData, upCollectedImgData, uploadImgInfoToYgt, getHistoryImg } from "@/service/image-service";
import ocrService from "@/service/ocr-service";
import commonQrCode from "@/components/imageNode/child/common-qrcode";
import imgTools from "@/components/imageNode/child/imgTools";

/**
 * 如果影像 PAGE_NAME 字段，保存有下标，则对影像数组进行排序
 */
const dealOldImageOrder = (oldImgList) => {
  if (!_.isArray(oldImgList)) {
    return;
  }
  for (let i = 0; i < oldImgList.length; i++) {
    if (_.isNaN(parseInt(oldImgList[i].PAGE_NAME))) {
      return oldImgList;
    }
  }

  return _.orderBy(oldImgList, ["PAGE_NAME"], ["asc"]);
};

export default {
  data () {
    return {
      itemClass: "self-ocr",
      minClsNum: 1,
      maxClsNum: 2,
      PidScanClsArr: "022,023,025,02d,02e,02k,02s,11h,11j,07d,056,1cf,071",//个人身份证明类别
      mergeClsArr:["071"],//需要合并上传的图片
      cameraOptions: {
        width: 300,
        height: 200,
        maxSize: 2 * 1024 * 1024,//默认图片最大大小
        isCompress: true,//是否压缩图片
        placeHolderType: "1",//占位图模式 0身份证 营业执照
      },
      clsImgInfo: null,//影像类别信息
      collectedImgData: [],//历史采集影像
      imageSwiper: false,
      isDisabled: false,
      image_index: 0,
      imgCls: "",
      bsno: "",
      triggerType: "custom",
      rules: [],
      ocrIdentifyType: "",//ocr识别类型
      isReturn: false, // 是否被退回标志
      isNeedSupple: false, // 是否需补采标志
      faceImgList: ["070"],
      dialogVisible: false, //二维码弹框显示
      code:"",
      isTest: "0",//测试开关
    };
  },
  components: {
    WebCamera,
    commonQrCode
  },
  props: ["field", "index", "isBaseUI", "busiLogic"],
  async created () {
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
    //测试时，识别失败不清除照片
    this.isTest = await oppService.getSysCommonParamsFromCacheObjs(
      "IS_FXC_TEST"
    );
    //初始化数据
    this.imgCls = this.field.PLACE_HOLDER;
    let that = this;
    return that.initInfo(this.imgCls);
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
  },
  computed: {
    //流水号
    APPT_SN: function () {
      return this.$store.state.apptSn;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    hasPageNum: function () {
      let item = this.collectedImgData[this.image_index];
      return item.PAGE_NUM ? true : false;
    },
    busiName () {
      return this.$store.state.busiName;
    },
    userType () {
      return this.$store.state.usertype;
    }
  },
  methods: {
    getSrc (item){
      if(item.localImgUrl&&item.localImgUrl.startsWith("blob:http:")){
        return item.localImgUrl;
      }
      if(!item.imgSrc){
        return "";
      }
      let base64Str = "data:image/jpg;base64," + item.imgSrc.replace(/data:(.*?),/, "");
      let localImgUrl = imgTools.getBase64URL(base64Str);
      item.localImgUrl = localImgUrl;
      return item.localImgUrl;
    },
    uploadImgList (imgList) {
      // imgList = dealOldImageOrder(imgList);
      return new Promise(async (resolve, reject) => {
        try {
          for (let i = 0; i < imgList.length; i++) {
            await this.dealImg(imgList[i], i);
          }
          this.field.hasUpload = "1";
          resolve(true);
        } catch (e) {
          let msg = _.isString(e) ? e : _.isString(e.message) ? e.message : "内部错误";
          reject("上传失败" + msg);
        }
      });
    },
    // async uploadImg (imgBase64, idx) {
    //   this.collectedImgData[idx].imgSrc = imgBase64;
    //   await this.dealImg(this.collectedImgData[idx], {}, idx);
    // },
    initInfo (imgCls) {
      if (!imgCls) {
        vm.alert("影像类别不能为空！");
        return;
      }
      if (_.get(this, "clsImgInfo.IMG_CLS") !== imgCls) {
        this.clsImgInfo = null;
      }
      //计算最小页数
      if (this.PidScanClsArr.indexOf(imgCls) != -1) {
        //个人证件类型只能采集2页
        this.minClsNum = 2;
        this.maxClsNum = 2;
      } else if (imgCls == "050" || imgCls == "g11j" || _.indexOf(this.faceImgList, imgCls) != -1) {
        //营业执照类型只能采集1页
        this.minClsNum = 1;
        this.maxClsNum = 1;
      } else {
        this.minClsNum = 1;
        this.maxClsNum = 30;//最大防止内存溢出，暂定为30
      }
      if (this.PidScanClsArr.indexOf(imgCls) != -1) {
        this.cameraOptions.placeHolderType = "0";
      } else if (this.imgCls == "050") {
        this.cameraOptions.placeHolderType = "1";
      }
      if (!this.clsImgInfo) {
        this.$store.commit(this.$types.UPDATE_LOADING, "正在获取影像类别配置，请稍候...");

        //获取影像类别数据
        this.getimgClsInfo(imgCls).then(async () => {
          if (this.clsImgInfo && (["0", "1", "2"]).indexOf(this.clsImgInfo.IMG_GET_MODE) === -1) {
            vm.alert("仅支持拍照影像的采集");
          } else {
            if(this.field.collectedImgData){
              //取缓存数据
              this.collectedImgData = this.field.collectedImgData;
              return;
            }
            //获取历史影像
            let oldImg = await this.getAllHistoryImg(imgCls) || [];
            this.isReturn = !_.isEmpty(oldImg.filter(item=>item.REVIEW_STATUS == "2"));
            let oldImgList = [];
            this.$store.commit(this.$types.UPDATE_LOADING, "正在回填历史影像，请稍候...");
            //判断是否有采集的历史影像 有的话需要展示
            if (oldImg.length) {
              this.field.IMG_SN = oldImg[0].IMG_SN;
              let imgDataList = oldImg[0].IMG_DATA;
              //存在历史影像则上传标志为已上传，无需再次上传
              this.field.hasUpload = "1";
              for(let i = 0; i < imgDataList.length;i++){
                oldImgList.push(Object.assign({}, oldImg[0], {
                  imgSrc : "data:image/jpg;base64," + imgDataList[i].imgSrc,
                  PAGE_NUM : imgDataList[i].PAGE_NUM
                }));
              }      
            }
            this.collectedImgData = [];
            if (!oldImgList.length) {
              oldImgList = [{}];
            }
            //初始化采集信息
            if (this.maxClsNum == 2) {
              //回填历史影像，最多只能采集两页的就只回填两页
              this.collectedImgData = [Object.assign({}, oldImgList[0], {
                IMG_CLS: imgCls,
                // imgSrc: _.get(oldImgList, "[0].imgSrc") || "",
                itemTitle: this.getItemTitle(0) || "采集正面",
                REVIEW_STATUS: _.get(oldImgList, "[0].REVIEW_STATUS") || "-1"
              }), Object.assign({}, oldImgList[1], {
                IMG_CLS: imgCls,
                // imgSrc: _.get(oldImgList, "[1].imgSrc") || "",
                itemTitle: this.getItemTitle(1) || "采集反面",
                REVIEW_STATUS: _.get(oldImgList, "[1].REVIEW_STATUS") || "-1"
              })];
            } else if(this.maxClsNum == 1){
              //只能回填一张的，默认填充最后一张 比如营业执照
              this.collectedImgData = [Object.assign({}, oldImgList[oldImgList.length-1], {
                IMG_CLS: imgCls,
                // imgSrc: _.get(oldImgList,`[${oldImgList.length-1}].imgSrc`) || "",
                itemTitle: this.getItemTitle(0) || "采集正面",
                REVIEW_STATUS: _.get(oldImgList, "[0].REVIEW_STATUS") || "-1"
              })];
            } else {
              _.map(oldImgList, (item, index) => {
                this.collectedImgData.push(Object.assign({}, item, {
                  IMG_CLS: imgCls,
                  // imgSrc: item.imgSrc || "",
                  itemTitle: this.getItemTitle(index) || "采集影像",
                  REVIEW_STATUS: item.REVIEW_STATUS || "-1"
                }));
              });
            }
            //如果回填后的影像小于最大页数，那么就加上 采集帧
            if (this.collectedImgData.length < this.maxClsNum) {
              this.collectedImgData.push({
                IMG_CLS: imgCls,
                imgSrc: "",
                itemTitle: "采集影像",
                REVIEW_STATUS: "-1"
              });
            }
          }
        }).finally(() => {
          this.myLoading({ showLoading: false });
        });
      }
    },
    getItemTitle (index) {
      this.field.FIELD_TITLE = this.field.FIELD_TITLE.replace("\\n", "\n");
      let titleArray = this.field.FIELD_TITLE.split("|") || [];
      return titleArray[index] || "";
    },
    getimgClsInfo (imgCls) {
      //todo test 待替换接口
      // return Promise.resolve([]);
      return this.$syscfg.K_Request("F0000042", { IMG_CLS: imgCls }).then((res) => {
        if (res.Code == "0" && res.Data) {
          this.clsImgInfo = res.Data[0] || {};
        } else {
          vm.alert("获取影像类别数据失败！");
        }
      });
    },
    // 根据当前影像采集列表（满足影像条件的）从影像系统获取当前流水已经采集的影像帧数据
    getPageList (imgCls) {
      // return Promise.resolve([]);
      let that = this;
      let bsno = this.$storage.getSession(this.$definecfg.B_SNO);
      // return getHistoryImg(bsno, imgCls);
      if (_.isEmpty(bsno)) {
        return [];
      }
      return that.$syscfg.K_Request("F0000038", { "B_SNO": bsno, IMG_CLS: imgCls }).then((data) => {
        if (data.Code == "0") {
          return data.Data;
        }
      });
    },
    //获取该客户该业务采集当前影像的YGT数据库表里的影像
    getAllHistoryImg (imgCls) {
      // return Promise.resolve([]);
      let that = this;
      let bsno = this.$storage.getSession(this.$definecfg.B_SNO);
      let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
      
      if (_.isEmpty(bsno)) {
        return [];
      }
      this.$store.commit(this.$types.UPDATE_LOADING, "正在获取历史影像，请稍候...");
      return that.$syscfg.K_Request("F0000039", { "B_SNO": bsno, IMG_CLS: imgCls,ID_CODE:_.get(busiInfo, "BIZ_DATA.KEY_INFO.NEW_ID_CODE","") }).then((data) => {
        if (data.Code == "0") {
          return data.Data;
        }
      }).catch(err=>{
        consoleError("获取历史影像失败！");
        return [];
      });
    },
    async onPhotoResult (res) {
      let imgSrc = res.imgBase64;
      //先进行ocr识别 只有身份证以及工商营业执照才识别
      let idType = "00";
      // if (["022", "050", "11h", "11j", "g11j","07d","056"].includes(this.imgCls)) {
      switch (this.imgCls) {
        case "050":
        case "g11j":
          idType = "10";
          break;
        case "02s":
          idType = "0s";
          break;
        default:
          break;
      }
      let flag = this.imgValidate(imgSrc, res);
      if(!flag){
        return false;
      }
      this.image_index = res.index;
      if (this.field.notOcr) {
        //不需要ocr识别就进入上传
        this.dealImg(this.collectedImgData[this.image_index], {}, this.image_index);
        return;
      }
      if (this.image_index == "0") {
        //consoleLog("正面，清除识别类型");
        this.ocrIdentifyType = "";
      }
      let that = this;
      that.$store.commit(that.$types.UPDATE_LOADING, "正在识别图片...");
      let currentItem = that.collectedImgData[that.image_index];
      currentItem.localImgUrl = "";
      currentItem.imgSrc = imgSrc;
      that.$set(that.collectedImgData, `${that.image_index}`, currentItem);
      ocrService.ocrIdentify(imgSrc, this.image_index == "0" ? "正面" : "反面", idType, this.ocrIdentifyType, that.userType).then((cardData) => {
        consoleLog("ocr识别结果", cardData);
        that.collectedImgData[that.image_index].REVIEW_STATUS = "1";
        if (that.image_index == "0" && cardData && cardData.ocrIdentifyType) {
          //正面识别保存港澳居住证识别类型，方便反面识别的时候使用
          that.ocrIdentifyType = cardData.ocrIdentifyType;
        }
        //营业执照只要确保识别返回类型字段是business_license就默认为识别成功了
        if(idType == "10"){
          if(cardData.type != "business_license"){
            this.alert("识别失败，请重新上传识别或手动填写资料");
            // that.collectedImgData[that.image_index].REVIEW_STATUS = "-1";             
          }
        }else{
          //正面没有识别到号码需要提示
          if((that.image_index == "0" && !cardData.ID_CODE) ||
            (that.image_index == "1" && !cardData.validity)){
            this.alert("识别失败，请重新上传识别或手动填写资料");
            // that.collectedImgData[that.image_index].REVIEW_STATUS = "-1";             
          }
        }
        
        // if(!cardData){//ocr识别失败也要允许上传
        //   return;
        // }
        //触发逻辑，去执行check关联函数进行数据回填
        that.field.cardData = cardData || {};
        // that.$refs[that.field.FIELD_ID].validate("custom"); // 自定义触发校验事件  
        //识别后无论是否成功触发fieldChange
        setTimeout(() => {
          if (this.isBaseUI) { 
            this.$emit("field-change", this.field);
          } else {
            this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: that.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
          }  
        },1000);
        that.field.hasUpload = "0";
        //拍照之后重置退回标记
        that.isReturn = false;
      }).catch(err => {
        consoleLog("证件OCR识别失败！",err);
        vm.alert("证件OCR识别失败！");
        that.collectedImgData[that.image_index].REVIEW_STATUS = "-1";
      }).finally(()=>{
        that.$store.commit(that.$types.UPDATE_LOADING, false);
      });
    },
    //上传图片
    async dealImg (imageMessage, cardData = {}, idx = 0) {
      if (this.field.notUpload && imageMessage.imgSrc) {
        //拍照完成 如果不提交就先保存到indexdb
        webStorage.set(this[this.field.FIELD_ID + "IMG_DATA"], imageMessage.imgBase64);
      } else if (imageMessage.imgSrc) {

        if(this.field.hasUpload === "1"){
          return "success";
        }
        try {
          let result = await this.photoUse(imageMessage, cardData, idx);
          if(result.Code == "0"){
            this.field.IMG_SN = result.Data[0].IMG_SN; 
          }
        } catch (e) {
          Object.assign(this.collectedImgData[idx], {
            imgSrc: "",
            itemTitle: "采集影像",
            REVIEW_STATUS: "-1"
          });
          vm.alert("上传图片失败:" + (e || "内部错误"));
        }
      } else {
        vm.alert("上传失败，图片数据为空");
      }
    },
    formatBase64 (imgSrc){
      return imgSrc.split("base64,")[1];
    },
    // 使用图片
    async photoUse (imageMessage, cardData, idx) {
      let that = this;
      let bsno = this.$storage.getSession(this.$definecfg.B_SNO);
      let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO) || {};
      let custInfo = this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
      let params = _.assign(busiInfo, cardData, custInfo);
      if (!bsno) {
        vm.alert("上传影像失败，影像流水不能为空！");
        return;
      }
      let userInfo = JSON.parse(this.$storage.getSession(this.$definecfg.USER_INFO)) || {};
      consoleLog("正在上传影像", imageMessage.IMG_CLS);
      if (!imageMessage.IMG_CLS) {
        that.alert("影像上传失败：无法获取到影像类别, 请退出重试!");
        throw "影像上传失败：无法获取到影像类别";
        return;
      }
      let mediaData = {
        "B_SNO": bsno,
        "BUSI_CODE": this.$storage.getJsonSession(this.$definecfg.BUSI_DEF_INFO).BUSI_CODE  || "",
        "CUST_CODE": params.CUST_CODE || "0",
        "SYS_CUST_NO": params.CUST_CODE || "",
        "CUST_NAME": params.CUST_NAME || "-1",
        "ID_TYPE": params.ID_TYPE || "-1",
        "ID_CODE": params.ID_CODE || "-1",
        "IMG_CLS": imageMessage.IMG_CLS,
        "IMG_FMT": that.clsImgInfo.IMG_FMT,
        "REVIEW_STATUS": "1",
        "REVIEW_REMARK": " ",
        OP_USER: userInfo.OP_CODE,
        OP_USER_CODE: userInfo.OP_CODE,
        OP_USER_NAME: userInfo.USER_NAME,
        "PAGE_NUM": imageMessage.PAGE_NUM || "",
        "ORG_CODE": params.CUST_ORG_CODE || params.INT_ORG,
        "ID_CARD": params.ID_CODE || "-1",
        "SYS_CODE": "99",
        "CHANNEL": "13",
        "BUSI_DETAIL": that.busiName || "000",
        "VIDEO_DESC": "",
        "PAGE_NAME": idx, // 用来保存图片的下标
        IMG_SN:this.field.IMG_SN,
        WHETHER_COMMON_CLS: "1",
        IS_MERGE: this.mergeClsArr.includes(imageMessage.IMG_CLS)
      };
      consoleLog("上传图片，pagenum", mediaData.PAGE_NUM);
      if(typeof imageMessage.imgSrc === "string"){
        mediaData.IMG_DATA = this.formatBase64(imageMessage.imgSrc);
      }else{
        mediaData.IMG_DATA = imageMessage.imgSrc;
      }
      this.$store.commit(this.$types.UPDATE_LOADING, "正在上传影像...");
      return new Promise((resolve, reject) => {
        upCollectedImgData(mediaData).then(res=>{
          if (res.Code != "0") {
            reject(res.Msg);
          } else {
            this.isReturn = false;
            resolve(res);
          }
        }).catch(function (e) {
          reject(e);
        }).finally(()=>{
          this.$store.commit(this.$types.UPDATE_LOADING, false);
        });
      });
    },
    //显示图片大图
    showSwipter (params) {
      let that = this;
      this.imageSwiper = params.flag;
      this.image_index = params.index;
    },
    closebigpage () {
      this.imageSwiper = false;
    },
    async deleteAllImg () {
      for (let i = 0; i < this.collectedImgData.length; i++) {
        await this.doImgDelete(i);
      }
    },
    doImgDelete (index) {
      let that = this;
      let item = that.collectedImgData[index];
      if (item.REVIEW_STATUS == "-1") {
        //未上传的不需要调用接口
        item.imgSrc = "";
        return;
      }
      let param = {
        IMG_SN: item.IMG_SN,
        PAGE_NUMS: item.PAGE_NUM,//多个以逗号分开
        B_SNO: this.$store.state.oldBizData.KIDM_SNO,//影像流水号
      };
      that.$store.commit(that.$types.UPDATE_LOADING, "正在删除影像...");
      return new Promise((resolve, reject) => {
        deleteCollectedImgData(param).then((data) => {
          if (data.Code == "0") {
            item.imgSrc = "";
            item.PAGE_NUM = "";
            item.REVIEW_STATUS = "-1";
            resolve(true);
          } else {
            throw data.Msg;
          }
        }).catch((err) => {
          reject("删除影像失败:" + err.toString());
        }).finally(()=>{
          that.$store.commit(that.$types.UPDATE_LOADING, false);
        });
      });
    },
    takephotoagain (index) {
      let that = this;
      if(that.isDisabled){
        alert("禁止操作");
        return false;
      }
      //调用子组件进行重拍
      let webRef = _.get(that.$refs, `webCamera${that.image_index}[0]`);
      webRef && webRef.openCamera && webRef.openCamera(true);
    },
    imgValidate (img, res){
      if(res.flag != "0"){
        this.alert(res.msg);
        return false;
      }
      if (!res.fileType || !/(JPG|JPEG|PNG)$/.test(res.fileType.toUpperCase())) {
        this.alert("仅支持上传图片格式!");
        return false;
      }
      return true;
    },
    imgDelete (index) {
      let that = this;
      this.confirm({
        messageText: "请确认是否删除当前影像？",
        confirmButtonText: "确定",
        confirmedAction: function () {
          return Promise.resolve(that.doImgDelete(index)).then(() => {
            consoleLog("删除成功");
          }).catch(e => {
            this.alert(e);
          });
        }
      });
    },
    openWindow (index){
      let item = this.collectedImgData[index];
      if(!item.localImgUrl){
        this.alert("无法打开，图片数据为空");
      }
      window.open(item.localImgUrl, this.clsImgInfo.IMG_CLS_NAME||"图片查看","width=1024,height=800,top = 200, left=400,menubar=no,toolbar=no, status=no,scrollbars=yes");
    },  
    validatorField: function (rule, value, callback) {
      let hasCollectImglist = this.collectedImgData.filter( item =>  ["0","1","4"].includes(item.REVIEW_STATUS));
      if (hasCollectImglist.length < this.minClsNum && this.isRequired && this.isShow) {
        // vm.alert("采集的影像页数小于最小页数");
        this.field.warnText = this.field.warnTextTpl || "请采集对应的影像";
        this.showErrorMsg = "请采集对应的影像";
        this.field.correct = false;
        this.field.DEFAULT_VALUE = "未采集";
        return callback(new Error(this.showErrorMsg));
      } else if (this.isReturn) {
        this.showErrorMsg = "退回的影像需要重新采集";
        this.field.DEFAULT_VALUE = "未采集";
        this.field.warnText = "请重新采集退回的影像";
        this.field.correct = false;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.DEFAULT_VALUE = "已采集";
        this.field.correct = true;
      }
      //识别后无论是否成功触发fieldChange
      if (this.isBaseUI) { // 多选框选中和都不选中都广播值变更事件
        this.$emit("field-change", this.field);
      } else {
        this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
      }
      return callback();
    },
    async finishScan (){
      let that = this;
      //先屏蔽监听
      // window.onbeforeunload = null;
      // //此处不能主动获取流水号，否则定时器会自动暂存当前PC数据，导致pc数据覆盖手机端数据
      // // //获取预约流水,扫码上传完成后需要获取流水号,更新流水数据，回填数据，获取最新影像
      // // await oppService.getBusiDataByApptSn(this.$store.state.apptSn);
      // // if (this.isBaseUI) {
      // //   this.$emit("click-button");
      // // } else {
      // //   let data = {};
      // //   data["MODULE_ID"] = this.field.MODULE_ID;
      // //   data["index"] = this.index;
      // //   data["FIELD_ID"] = this.field.FIELD_ID;
      // //   data["GROUP_ID"] = this.$parent.$parent.$parent.moduleItem.GROUP_ID;
      // //   this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      // // }
      // //重新初始化ocr组件
      // that.clsImgInfo = null;
      // return that.initInfo(that.imgCls);
    },
    beforeOpenCamera (idx) {
      if(this.isDisabled){
        alert("禁止操作");
        return false;
      }
      if( this.busiLogic.beforeOpenOCRCamera){
        return this.busiLogic.beforeOpenOCRCamera(this.field, idx, this.collectedImgData);
      }else{
        return true;
      }
    }
  },
  watch: {
    "field.PLACE_HOLDER" (val) {
      //影像类别变化，重新初始化数据
      this.imgCls = val;
      return this.initInfo(this.imgCls);
    }
  },
  beforeDestroy (){
    //缓存图片
    // this.field.collectedImgData = this.collectedImgData;
  },
};
</script>

<style lang="less">
.el-form-item.self-ocr {
  height: 256px;
  width: 100%;
  margin: 0;
  // .el-dialog__header{
  //   width: 100%;
  //   height: 42px;
  //   padding: 12px 0;
  //   background-image: linear-gradient(90deg, #F4E4CE 0%, #FFFFFF 100%);
  //   .el-dialog__headerbtn{
  //     position: absolute;
  //     top: 8px;
  //     right: 20px;
  //   }
  //   span{
  //     display: inline-block;
  //     height: 17px;
  //     margin-left: 18px;
  //     font-family: PingFangSC-Semibold;
  //     font-size: 14px;
  //     color: #E5C48A;
  //     letter-spacing: 0;
  //     line-height: 16.8px;
  //     font-weight: 600;
  //   }
  // }
  .imgList-box {
    height: 246px;
    display: flex;
    flex-direction: row;
    margin-left: 40px;
    width: 1300px;
    align-items: center;
    justify-content: center;
    .returnImg {
      position: absolute;
      top: -0.25rem;
      left: 0.6rem;
      font-size: 16px;
      font-weight: 600;
      color: red;
    }
    .webCamera-box{
      display: flex;
      width: auto;
      overflow-x: auto;
      overflow-y: hidden;
      padding-bottom: 0.45rem;
      margin-top: 0.4rem;
      margin-right: 0.4rem;
      &::-webkit-scrollbar{
        display: block;
        height: 6px;
      }
      // 浏览器失焦的样式
      ::-webkit-scrollbar-thumb:window-inactive {
        // background: rgba(255, 0, 0, 0.4);
        // background: green;
      }
     
    }
    .common-qrcode{
      width: 346px;
    }
    .web-text {
      height: 249px;
      padding: 113px 0;
      line-height: 22px;
      margin-right: 40px;
    }

    .web-twocode {
      width: 346px;
      height: 249px;
    }

    .web-margin {
      margin-left: 0;
      margin-right: 40px;
    }
  }

  .swiper_show {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 30px 44px 100px 44px;
    box-sizing: border-box;
    z-index: 850;
    background-color: rgba(0, 0, 0, 0.9);

    .swiperClose {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 20px;
      height: 20px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .dealButtons {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;
     box-sizing: border-box;

      .el-button {
        background: rgba(0, 0, 0, 0);
        padding: 0;
      }

      .takeagain {
        // left: 40px;
        // bottom: 30px;
        width: 98px;
        height: 42px;
        border-radius: 24px;
        border: 1px solid #fff;
        color: #fff;
        font-size: 16px;
        // line-height:42px;
        text-align: center;
        // background:rgba(0,0,0,0);
      }

      .imgclose {
        // position: absolute;
        // right: 40px;
        // bottom: 30px;
        width: 98px;
        height: 42px;
        border-radius: 24px;
        border: 1px solid #fff;
        color: #fff;
        font-size: 16px;
        text-align: center;
      }

      .imgclose:after {
        height: 0;
        border: 0;
      }
      .openNew{
        position: absolute;
        right: 150px;
        width: 150px;
        height: 42px;
        border-radius: 24px;
        border: 1px solid #fff;
        color: #fff;
        font-size: 16px;
        text-align: center;
      }
      .imgDelete {
        position: absolute;
        bottom: 35px;
        right: 200px;
        width: 30px;
        height: 30px;
        background: url("~@img/newCode/old/garbagebin.svg");
        background-size: 30px 30px;
      }
    }

    .currentDealImg {
      width: 100%;
      height: 100%;
      text-align: center;
      display: flex;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
      }

      .noImg {
        color: white;
        text-align: center;
        font-size: 20px;
        margin-top: 350px;
      }
    }
  }
  
  .el-form-item__error {
    margin-left: 0px;
    padding-top: 30px;
    width: 100%;
    text-align: left;
    left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/normalOcrItem.vue